import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../hooks/useAuth';

export function RequireUnauth({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth?.user.isAuthenticated) {
    if (auth?.user.matchPlatform) {
      return <Navigate to={auth.user.loginSuccessUrl || '/'} state={{ from: location }} replace />;
    }
    window.location.href = auth.user.loginSuccessUrl || '/';
  }

  return children;
}
